import { roundOffNumber } from 'utils/common';
import {
  DEFAULT_TXN_VALUE,
  USD_TO_INR_RATE,
  PAYPAL_FEES,
  CURRENCY_CONVERSION_FEES,
} from './constants';

const getTransactionValue = charges => ({
  withoutMarkup: roundOffNumber(DEFAULT_TXN_VALUE),
  withMarkup: roundOffNumber(
    DEFAULT_TXN_VALUE + charges * 0.01 * DEFAULT_TXN_VALUE,
  ),
});

const getPaypalValue = transactionValue => ({
  withMarkup: roundOffNumber(transactionValue.withMarkup / USD_TO_INR_RATE),
  withoutMarkup: roundOffNumber(
    transactionValue.withoutMarkup / USD_TO_INR_RATE,
  ),
});

const getPaypalFees = paypalCharges => ({
  withMarkup: roundOffNumber(+paypalCharges.withMarkup * (PAYPAL_FEES * 0.01)),
  withoutMarkup: roundOffNumber(
    +paypalCharges.withoutMarkup * (PAYPAL_FEES * 0.01),
  ),
});

const getCurrencyConversionFees = paypalCharges => ({
  withMarkup: roundOffNumber(
    +paypalCharges.withMarkup * (CURRENCY_CONVERSION_FEES * 0.01),
  ),
  withoutMarkup: roundOffNumber(
    +paypalCharges.withoutMarkup * (CURRENCY_CONVERSION_FEES * 0.01),
  ),
});

export const calculateForexMarkup = (charges: number) => {
  const transactionValue = getTransactionValue(charges);
  const paypalValue = getPaypalValue(transactionValue);
  const paypalFees = getPaypalFees(paypalValue);
  const currencyConversionFees = getCurrencyConversionFees(paypalValue);
  const amountSettled = {
    withMarkup: roundOffNumber(
      Number(paypalValue.withMarkup) -
        (Number(paypalFees.withMarkup) +
          Number(currencyConversionFees.withMarkup)),
    ),
    withoutMarkup: roundOffNumber(
      Number(paypalValue.withoutMarkup) -
        (Number(paypalFees.withoutMarkup) +
          Number(currencyConversionFees.withoutMarkup)),
    ),
  };

  const amountSettledInINR = {
    withMarkup: roundOffNumber(+amountSettled.withMarkup * USD_TO_INR_RATE),
    withoutMarkup: roundOffNumber(
      +amountSettled.withoutMarkup * USD_TO_INR_RATE,
    ),
  };

  const effectiveCost = {
    withMarkup: roundOffNumber(
      Number(transactionValue.withoutMarkup) -
        Number(amountSettledInINR.withMarkup),
    ),
    withoutMarkup: roundOffNumber(
      Number(transactionValue.withoutMarkup) -
        Number(amountSettledInINR.withoutMarkup),
    ),
  };

  const effectiveCostInPercentage = {
    withMarkup: roundOffNumber(
      (Number(effectiveCost.withMarkup) / transactionValue.withoutMarkup) * 100,
    ),
    withoutMarkup: roundOffNumber(
      (Number(effectiveCost.withoutMarkup) /
        Number(transactionValue.withoutMarkup)) *
        100,
    ),
  };

  return {
    transactionValue,
    paypalValue,
    paypalFees,
    currencyConversionFees,
    amountSettled,
    amountSettledInINR,
    effectiveCost,
    effectiveCostInPercentage,
  };
};
